import React, { useState } from 'react';
import { IFooterTab, Tabs } from '../Tabs';
import { SUB_TABS_TEXT, TABS, tabType } from '../constants';
import { TEXT_SETTINGS_MORE, TEXT_SETTINGS_TITLE } from './constants';
import { Settings } from './Settings';
import { useSelector } from 'react-redux';

interface ITextSubFooter {
    tabSelection: (tab: tabType) => void
}

export type SettingsType = 'more' | 'outline' | 'layers' | 'color' | 'font' |'edit'| undefined

export const TextSubFooter = (props: ITextSubFooter) => {
    const { tabSelection } = props;

    const activeObjs = useSelector((state: any) => state.activeObjs) || {}

    const [settingsType, setSettingsType] = useState(undefined as SettingsType)

    const tabs: IFooterTab[] = [
        {
            imageSrc: "./assets/img/icons/Mobile/text.svg",
            title: SUB_TABS_TEXT.TEXT.title,
            onClick: () => {setSettingsType('edit') },
        },
        {
            imageSrc: "./assets/img/icons/text_icn.svg",
            title: SUB_TABS_TEXT.FONT.title,
            onClick: () => { setSettingsType('font') },
        },
        {
            imageSrc: "./assets/img/icons/Mobile/color.svg",
            title: SUB_TABS_TEXT.COLOR.title,
            onClick: () => { setSettingsType('color') },
        },
        {
            imageSrc: "./assets/img/icons/Mobile/outline.svg",
            title: SUB_TABS_TEXT.OUTLINE.title,
            onClick: () => { setSettingsType('outline') },
        },
        {
            imageSrc: "./assets/img/icons/Mobile/more_icn.svg",
            title: SUB_TABS_TEXT.MORE.title,
            onClick: () => { setSettingsType('more') },
        },
        {
            imageSrc: "./assets/img/icons/Mobile/layers_icn.svg",
            title: SUB_TABS_TEXT.LAYERS.title,
            onClick: () => { setSettingsType('layers') },
        }
    ]

    return <Tabs mainTabItems={tabs} settingsTitle={settingsType && TEXT_SETTINGS_TITLE}>
        <Settings type={settingsType} />
    </Tabs>
}